<template>
    <span>
        <b-button
            @click="$bvModal.show(editModalId)"
            class="align-baseline mr-1"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            @click="$bvModal.show(deleteModalId)"
            class="align-baseline"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal :id="deleteModalId" title="Delete Metadata" @ok="deleteMetaData"
            >Delete Metadata for Amenity?</modal
        >
        <create-edit-amenity-meta-data-modal
            ref="edit_amenity_metadata"
            @submit="updateAmenityMetadata"
            :values="params.data"
            :modalId="editModalId"
        />
    </span>
</template>

<script>
import Modal from '../../generic/modal/modal.vue';
import CreateEditAmenityMetaDataModal from './create-edit-amenity-meta-data-modal.vue';
import { generateRequestBody } from './helpers';
import { formatResponseError } from '../../../utils/api';

export default {
    components: {
        Modal,
        CreateEditAmenityMetaDataModal,
    },
    computed: {
        editModalId() {
            return 'edit-modal' + this.params.data.id;
        },
        deleteModalId() {
            return 'delete-modal' + this.params.data.id;
        },
    },
    methods: {
        async updateAmenityMetadata(amenityObj, amenitiesList) {
            try {
                const body = generateRequestBody(amenityObj, amenitiesList);
                this.params.updateAmenityMetadata &&
                    this.params.updateAmenityMetadata(
                        this.params.data.id,
                        body
                    );
            } catch (e) {
                const { generic, fields } = formatResponseError(e);

                if (generic) {
                    this.errorToast({ text: generic });
                } else {
                    this.errorToast({
                        text: 'Could not update amenity metadata',
                    });
                }
                if (!generic && !isEmpty(fields)) {
                    this.$refs.edit_amenity_metadata.$children[0].setErrors(
                        fields
                    );
                }
            }
        },
        async deleteMetaData() {
            this.params.deleteAmenityMetadata &&
                this.params.deleteAmenityMetadata(this.params.data.id);
        },
    },
};
</script>
